// eslint-disable
export const isTouchDevice = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  const mq = query => window.matchMedia(query).matches;

  // eslint-disable-next-line no-mixed-operators,no-undef
  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
};

export const isEdge = () => /Edge/.test(navigator.userAgent);

export const isMobile = () => window.innerWidth < 1024;
